/* eslint-disable */

export default {
  init() {
    console.log('\t\t init videos.js');
    (function( app_api, $, undefined ) {
      app_api.settings = {
        _debug: true,
      }
      
      app_api.initial = {
        _hasArgs: false,
        _params: {},
        _filter: -1,
        _posts: -1,
      }

      app_api.get_uri_params = function() {
        var _return = false;
        const urlSearchParams = new URLSearchParams(window.location.search);
        app_api.initial._params = Object.fromEntries(urlSearchParams.entries());
        if(Object.keys(app_api.initial._params).length>0) { _return = app_api.initial._hasArgs = true; }
        return _return;
      };

      app_api.handle_params = function(){
        if(app_api.initial._params.hasOwnProperty('f')) {
          var _user_filter = app_api.initial._params['f'];
          var _dict_data = {
            "all": {"filter": 1, "posts": 1},
            "blog": {"filter": 5, "posts": 6},
            "press_release": {"filter": 6, "posts": 7},
            "infographic": {"filter": 8, "posts": 9},
            "brochure": {"filter": 2, "posts": 3},
            "ebook": {"filter": 3, "posts": 4},
            "case_study": {"filter": 4, "posts": 5},
            "video": {"filter": 10, "posts": 10},
            "whitepaper": {"filter": 11, "posts": 11},
          }
          if(_dict_data.hasOwnProperty(_user_filter)) {
            app_api.initial._filter = _dict_data[_user_filter].filter;
            app_api.initial._posts = _dict_data[_user_filter].posts;
          }
        }
      }
      
    }( window.app_api = window.app_api || {}, jQuery ));

    if(app_api.get_uri_params()){
      app_api.handle_params();
      console.log('\t\t\t handle_param - func fired');
    }
  },
  finalize() {
    const axios = require('axios');
    console.log('\t\t finalize() fire\n\t\t\t user params\n\t\t\t ' + JSON.stringify(app_api.initial));

    //default for videos (if no uri with user filter (?f= in url))
    var _data = {
      posts: null,
      category_set_ids: new Set(),
      active1: false,
      active2: false,
      active3: false,
      active4: false,
      active5: false,
      active6: false,
      active7: false,
      active8: false,
      active10: true,
      active11: false,
      loading: false,
      per_page: 8,
      most_recent_method_call: 'none',
      lightboxActive: false,
      videoLightboxActive: false
    };

    // new (if uri has user filter (?f= in url))
    if(app_api.initial._filter > -1){ _data = {
        posts: null,
        category_set_ids: new Set(),
        active1: (app_api.initial._filter==1)?true:false,
        active2: (app_api.initial._filter==2)?true:false,
        active3: (app_api.initial._filter==3)?true:false,
        active4: (app_api.initial._filter==4)?true:false,
        active5: (app_api.initial._filter==5)?true:false,
        active6: (app_api.initial._filter==6)?true:false,
        active7: (app_api.initial._filter==7)?true:false,
        active8: (app_api.initial._filter==8)?true:false,
        active10: (app_api.initial._filter==10)?true:false,
        active11:  (app_api.initial._filter==11)?true:false,
        loading: false,
        per_page: 8,
        most_recent_method_call: 'none',
        lightboxActive: false,
        videoLightboxActive: false
      };
    }

    app_api.app = new Vue({
      el: '#media-sort',
      data: _data,
      mounted () {
        if(app_api.initial._posts>-1){
          if(app_api.initial._posts == 1) {
            this.getAllPosts();
          }
          else{
            this.getPosts(app_api.initial._posts);
          }
        }
        else{
          this.getPosts(10); // default for videos
        }
      },
      methods: {
        getPosts(category_id) {
          if(this.loading == true) return
          this.loading = true
          if( this.category_set_ids.has(category_id) ) {
            this.category_set_ids.delete(category_id)
          }
          else {
            this.category_set_ids.clear();  //  added 2021-3-19 - end user will not be allowed to click multiple filtering tabs at once, we clear all filters, then add the intended
            this.category_set_ids.add(category_id)
          }
          //  2021-3-19 updated
          //  old comment - if everything is deselected, don't perform the get request and exit the function
          if(this.category_set_ids.size == 0) {
            //  code for 2021-3-19
            this.loading = false;
            if(this.active1 == false) this.toggleActive1(); //  note: requires this.loading to be set to false before
            this.getAllPosts();
            return;
            //  code prior to 2021-3-19 (clears the page, no results)
            // this.posts = null
            // this.loading = false
            // return
          }
          let category_array_ids = Array.from(this.category_set_ids)
          let category_string_ids = category_array_ids.join(",")
          //add this to our load_more function
          this.most_recent_method_call = '/wp-json/wp/v2/posts?categories=' + category_string_ids + '&orderby=date&order=desc&per_page='
          //reset load more button
          this.per_page = 8;
          //get request with constructed string of category ids
          axios
          .get('/wp-json/wp/v2/posts?categories=' + category_string_ids + '&orderby=date&order=desc&per_page=8')
          //.then( response => (this.posts = response.data)) //does not remove password protected articles
          .then( response => (this.posts = response.data.filter(post => !post.content.protected)))  
          .finally(() => this.loading = false)
        },
        getAllPosts() {
          if(this.loading == true) return

          if(this.active1 === false) {
            this.posts = null
            return
          }

          this.loading = true

          this.category_set_ids.clear()
          //add this to our load_more function
          this.most_recent_method_call = '/wp-json/wp/v2/posts?orderby=date&order=desc&per_page='
          //reset load more button
          this.per_page = 8;
          axios
          .get('/wp-json/wp/v2/posts?orderby=date&order=desc&per_page=8')
          //.then( response => (this.posts = response.data)) //does not remove password protected articles
          .then( response => (this.posts = response.data.filter(post => !post.content.protected)))  
          .finally(() => this.loading = false)                  
        },
        toggleActive1: function toggleActive1() {
          if(this.loading == true) { return }
          this.active1 = true
          this.active2 = false
          this.active3 = false
          this.active4 = false
          this.active5 = false
          this.active6 = false
          this.active7 = false
          this.active8 = false
          this.active10 = false
          this.active11 = false
        },
        toggleActive2: function toggleActive2() {
          if(this.loading == true) { return }          
          this.active1 = false
          this.active2 = true
          this.active3 = false
          this.active4 = false
          this.active5 = false
          this.active6 = false
          this.active7 = false
          this.active8 = false
          this.active10 = false
          this.active11 = false
        },
        toggleActive3: function toggleActive3() {
          if(this.loading == true) { return }
          this.active1 = false
          this.active2 = false
          this.active3 = true
          this.active4 = false
          this.active5 = false
          this.active6 = false
          this.active7 = false
          this.active8 = false
          this.active10 = false
          this.active11 = false
        },
        toggleActive4: function toggleActive4() {
          if(this.loading == true) { return }          
          this.active1 = false
          this.active2 = false
          this.active3 = false
          this.active4 = true
          this.active5 = false
          this.active6 = false
          this.active7 = false
          this.active8 = false
          this.active10 = false
          this.active11 = false
        },
        toggleActive5: function toggleActive5() {
          if(this.loading == true) { return }          
          this.active1 = false
          this.active2 = false
          this.active3 = false
          this.active4 = false
          this.active5 = true
          this.active6 = false
          this.active7 = false
          this.active8 = false
          this.active10 = false
          this.active11 = false
        },
        toggleActive6: function toggleActive6() {
          if(this.loading == true) { return }          
          this.active1 = false
          this.active2 = false
          this.active3 = false
          this.active4 = false
          this.active5 = false
          this.active6 = true
          this.active7 = false
          this.active8 = false
          this.active10 = false
          this.active11 = false
        },
        toggleActive7: function toggleActive7() {
          if(this.loading == true) { return }          
          this.active1 = false
          this.active2 = false
          this.active3 = false
          this.active4 = false
          this.active5 = false
          this.active6 = false
          this.active7 = true
          this.active8 = false
          this.active10 = false
          this.active11 = false
        },
        toggleActive8: function toggleActive8() {
          if(this.loading == true) { return }          
          this.active1 = false
          this.active2 = false
          this.active3 = false
          this.active4 = false
          this.active5 = false
          this.active6 = false
          this.active7 = false
          this.active8 = true    
          this.active10 = false    
          this.active11 = false
        },
        toggleActive10: function toggleActive10() {
          if(this.loading == true) { return }          
          this.active10 = true
          this.active1 = false
          this.active2 = false
          this.active3 = false
          this.active4 = false
          this.active5 = false
          this.active6 = false
          this.active7 = false
          this.active8 = false        
          this.active11 = false
        },
        toggleActive11: function toggleActive10() {
          if(this.loading == true) { return }      
          this.active11 = true
          this.active1 = false
          this.active2 = false
          this.active3 = false
          this.active4 = false
          this.active5 = false
          this.active6 = false
          this.active7 = false
          this.active8 = false    
          this.active10 = false
        },
        loadMore() {
          this.per_page = this.per_page + 8
          axios
          .get(this.most_recent_method_call + this.per_page)
          //.then( response => (this.posts = response.data)) //does not remove password protected articles
          .then( response => (this.posts = response.data.filter(post => !post.content.protected)))  
          .finally(() => this.loading = false)
        },
        loadLightbox(result_id) {
          this.lightboxActive = !this.lightboxActive;
          jQuery('#input_7_9').val(result_id);
        },
        loadVideoLightbox(inputUrl) {
          this.videoLightboxActive = !this.videoLightboxActive
          jQuery('#video-lightbox-iframe').attr('src',inputUrl+"?feature=oembed&enablejsapi=1");
        },
        setURI: function(_pass) {
          var to_set = _pass; // value that you want to set
          var url = new URL(window.location);
          (url.searchParams.has('f') ? url.searchParams.set('f', to_set) : url.searchParams.append('f', to_set));

          // if you want to append into URL without reloading the page
          url.search = url.searchParams;
          url        = url.toString();
          history.pushState({}, null, url);
        }
      }
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/videos.js